const isOneWebDomainRuntime = () => {
    return !!window.AvaAppConfig;
};

export default isOneWebDomainRuntime;
